import { Badge, Tooltip } from 'antd'
import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { KolThumbnail } from '@/components/common/kol-thumbnail'
import { useIntl } from '@/i18n/hooks/use-intl'
import { Nullable } from '@/types/nullable'

export interface Brand {
  name: string
  platformName: string
  thumbnailUrl: string
  mentionCount: number
  etlAt: Nullable<string>
}

interface MentionedBrandProps {
  brand: Brand
  isKolInfoLocked: Nullable<boolean>
  onClick?: () => Promise<void>
}

const MentionedBrand: FunctionComponent<MentionedBrandProps> = ({
  brand,
  isKolInfoLocked,
  onClick,
}) => {
  const { formatMessage } = useIntl()

  return (
    <Tooltip
      title={formatMessage(
        { id: 'kol:mentioned_count' },
        { mentionedCount: brand.mentionCount },
      )}
    >
      <Box $cursor={isKolInfoLocked ? 'default' : 'pointer'} onClick={onClick}>
        <KolThumbnail imageSize='small' src={brand.thumbnailUrl} />
        <BrandName>{brand.name}</BrandName>
        <Badge count={brand.mentionCount} />
      </Box>
    </Tooltip>
  )
}

const Box = styled.div<{ $cursor: 'default' | 'pointer' }>`
  cursor: ${({ $cursor }): string => $cursor};
  border-radius: 4px;
  border: 1px solid ${({ theme }): string => theme.colors.border.border};
  background: ${({ theme }): string => theme.colors.background.grey};
  padding: 6px 12px;
  display: flex;
  gap: 5px;
  align-items: center;
  overflow: hidden;

  .ant-badge-count {
    background: ${({ theme }): string => theme.colors.level.level3};
  }
`

const BrandName = styled.div`
  color: ${({ theme }): string => theme.colors.text.primary};
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
`

export default MentionedBrand
